/** Month + year filter for the ledger. Month "all" (or blank) spans the year, or everything. */
export class LedgerPeriod {
    month;
    year;
    constructor(month, year) {
        this.month = month;
        this.year = year;
    }
    static all() {
        return new LedgerPeriod("all", "");
    }
    /** ISO date prefix rows must start with; empty matches everything. */
    prefix(now = new Date()) {
        if (this.month === "all" || !this.month)
            return this.year ? `${this.year}-` : "";
        return `${this.year || now.getFullYear()}-${String(this.month).padStart(2, "0")}-`;
    }
    matches(date, now) {
        const p = this.prefix(now);
        return !p || String(date || "").startsWith(p);
    }
}
/** A completed sale, in dollars. */
export class LedgerSaleRow {
    id;
    listingId;
    make;
    model;
    year;
    soldPrice;
    purchaseCost;
    soldDate;
    buyerName;
    constructor(id, listingId, make, model, year, soldPrice, purchaseCost, soldDate, buyerName) {
        this.id = id;
        this.listingId = listingId;
        this.make = make;
        this.model = model;
        this.year = year;
        this.soldPrice = soldPrice;
        this.purchaseCost = purchaseCost;
        this.soldDate = soldDate;
        this.buyerName = buyerName;
    }
    static fromBridge(s) {
        return new LedgerSaleRow(s.id, s.listingId, s.make, s.model, s.year, s.soldCents / 100, s.purchaseCents / 100, s.soldDate, s.buyerName);
    }
    profit() {
        return this.soldPrice - this.purchaseCost;
    }
}
/** A dealer expense, in dollars. Negative amounts are income (internal margin). */
export class LedgerExpenseRow {
    id;
    amount;
    category;
    description;
    date;
    constructor(id, amount, category, description, date) {
        this.id = id;
        this.amount = amount;
        this.category = category;
        this.description = description;
        this.date = date;
    }
    static fromBridge(e) {
        return new LedgerExpenseRow(e.id, e.amountCents / 100, e.category, e.note, e.date);
    }
}
/** Year-to-date headline numbers, in dollars. */
export class YearSummary {
    salesCount;
    revenue;
    expenses;
    netProfit;
    constructor(salesCount, revenue, expenses, netProfit) {
        this.salesCount = salesCount;
        this.revenue = revenue;
        this.expenses = expenses;
        this.netProfit = netProfit;
    }
    static empty() {
        return new YearSummary(0, 0, 0, 0);
    }
    static fromBridge(raw) {
        const sold = Number(raw.soldCents ?? 0);
        const expense = Number(raw.expenseCents ?? 0);
        const purchase = Number(raw.purchaseCents ?? 0);
        const gross = Number(raw.grossProfitCents ?? sold - purchase - expense);
        return new YearSummary(Number(raw.salesCount ?? 0), sold / 100, expense / 100, gross / 100);
    }
}
/** Dollars to wire cents without float drift. */
export function dollarsToCents(amount) {
    return Math.round(amount * 100);
}
//# sourceMappingURL=DealerLedger.js.map